<script setup>
import api from "../api/api";
</script>

<template>
  <div class="main-survey-box">
    <div>
      <iframe
        :src="`${passedRouteParams.surveyTemplateLink}?survey_assignment_id=${passedRouteParams.surveyAssignmentLink}&ind_id=${passedRouteParams.indId}&org_id=${passedRouteParams.orgId}&subOrg_id=${passedRouteParams.suborgId}&first_name=${userData.first_name}&last_name=${userData.last_name}&rand=${rand}&iteration_id=${passedRouteParams.iteartionId}&survey_template_id=${passedRouteParams.surveyTemplateId}&run_mode=${passedRouteParams.runMode}&lang=${(window.Weglot && Weglot.getCurrentLang && Weglot.getCurrentLang()) || 'en'}&show_switcher=${userData.languages_available && userData.languages_available.split(',').map(l => l.trim()).filter(l => l !== 'en').length > 0 ? '1' : '0'}`"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
/* global Weglot */
export default {
  component: [],
  props: {
    userData: Object,
    brandData: Object,
  },
  data: () => ({
    passedRouteParams: {},
    rand: "",
    surveyOpenStatus: null,
    prepolulateEndpoint: "",
    surveyVersion: null,
    prepopulateData: [],
  }),
  async mounted() {
    this.passedRouteParams = JSON.parse(this.$route.params.data)
    console.log(this.passedRouteParams)
    this.rand = Math.random()

    if (this.passedRouteParams.runMode !== "ReadOnly") {
      // get survey assignment data
      try {
        const res = await api.get(
          `survey-assignment/view-one/${this.passedRouteParams.surveyAssignmentLink}`
        );
        if (res.status === 200) {
          this.surveyOpenStatus = res.data.survey_opened
        }
      } catch (e) {
        console.log(e)
      }

      if (this.surveyOpenStatus !== 1) {
        // survey_opened is 0 — check if results already exist (old surveys safety net)
        let hasResults = false
        try {
          const res = await api.get(`/survey-results/check/${this.passedRouteParams.surveyAssignmentLink}`)
          if (res.status === 200) {
            hasResults = res.data.hasResults
          }
        } catch (e) {
          console.log(e)
        }

        if (hasResults) {
          try {
            await api.put(`survey-assignment/survey-opened/${this.passedRouteParams.surveyAssignmentLink}`, {
              survey_opened: 1,
              modified_by: this.passedRouteParams.indId,
            })
          } catch (e) {
            console.log(e)
          }
        } else {
          // no results and survey_opened is 0 — old survey, run prepopulate as before
          try {
            const endpointRes = await api.get(`survey-templates/prepopulate/${this.passedRouteParams.surveyTemplateId}`)
            if (endpointRes.status === 200) {
              this.prepolulateEndpoint = endpointRes.data.pre_populate_survey_endpoint
            }
          } catch (e) {
            console.log(e)
          }

          try {
            const typeRes = await api.get(`/survey-templates/survey-type/${this.passedRouteParams.surveyTemplateId}`)
            if (typeRes.status === 200) {
              this.surveyVersion = typeRes.data.survey_version
              this.prepopulateData = typeRes.data.prepopulate_data
            }
          } catch (error) {
            console.log(error)
          }

          if (this.surveyVersion === 1) {
            try {
              const res = await api.post(`survey-results/populate/${this.prepolulateEndpoint}`, {
                survey_assignment_id: this.passedRouteParams.surveyAssignmentLink,
                org_id: this.passedRouteParams.orgId,
                suborg_id: this.passedRouteParams.suborgId,
              });
              if (res.status === 200) {
                try {
                  await api.put(`survey-assignment/survey-opened/${this.passedRouteParams.surveyAssignmentLink}`, {
                    survey_opened: 1,
                    modified_by: this.passedRouteParams.indId,
                  });
                } catch (e) {
                  console.log(e)
                }
              }
            } catch (e) {
              console.log(e)
            }
          }

          if (this.surveyVersion === 2) {
            try {
              const res = await api.post(`/survey-results/populate/${this.passedRouteParams.surveyAssignmentLink}/${this.passedRouteParams.orgId}/${this.passedRouteParams.suborgId}`, this.prepopulateData)
              if (res.status === 200) {
                try {
                  await api.put(`survey-assignment/survey-opened/${this.passedRouteParams.surveyAssignmentLink}`, {
                    survey_opened: 1,
                    modified_by: this.passedRouteParams.indId,
                  });
                } catch (e) {
                  console.log(e)
                }
              }
            } catch (error) {
              console.log(error)
            }
          }
        }
      }
    }

    // Send language to survey iframe via postMessage
    const lang = (window.Weglot && Weglot.getCurrentLang && Weglot.getCurrentLang()) || 'en';
    if (lang && lang !== 'en') {
      this.$nextTick(() => {
        const iframe = this.$el.querySelector('iframe');
        if (iframe) {
          iframe.addEventListener('load', () => {
            console.log('[MySurvey] Sending SET_LANGUAGE postMessage to survey iframe, lang:', lang);
            iframe.contentWindow.postMessage(
              { type: 'SET_LANGUAGE', lang: lang },
              window.location.origin
            );
            console.log('[MySurvey] postMessage sent');
          });
        }
      });
    }
  },
  unmounted() {
    this.$emit("passHeaderSubjectFullName", "");
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 78vh;
  overflow: hidden;
  margin: 5px 0;
}
</style>
